import { luhn } from './luhn'
import { mod11 } from './mod11'

export function checkSwedishOrganizationNumber(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  return accountNumber.length === 10 && luhn(accountNumber)
}

export function checkNorwegianOrganizationNumber(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  return accountNumber.length === 9 && mod11(accountNumber)
}

export function checkDanishOrganizationNumber(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  return accountNumber.length === 8
}
